import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IOrderTemplateRepository } from '@/coreInfrastructureModule/interfaces/IOrderTemplateRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { OrderTemplateUploadUrl } from '../domains/valueObjects/presignedUrl';
import { OrderTemplateAdapter } from '../adapters/orderTemplateAdapter';
import { OrderTemplatePresignedUploadRequest } from '@/coreInfrastructureModule/axios/generated/orderManage/api';

/**
 * 発注テンプレートのアップロード用URLを発行するユースケース
 */
export class CreateOrderTemplateUploadUrlUseCase {
  /**
   * コンストラクタ
   * @param repository - Presigned URLの発行を担うリポジトリ
   */
  constructor(private readonly repository: IOrderTemplateRepository) {}

  /**
   * アップロード用URLを発行する
   * @param request - アップロード条件
   */
  public Execute = async (request: OrderTemplatePresignedUploadRequest): Promise<INetworkResult<OrderTemplateUploadUrl, IError>> => {
    const result = await this.repository.createUploadUrl(request);
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: OrderTemplateAdapter.toUploadUrl(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
